import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["items"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import Box from '@rexlabs/box';
import { useToken, useStyles, StyleSheet, padding, border, text, mq } from '@rexlabs/styling';
import Icons from '@rexlabs/icons';
import { Breakpoints } from '@rexlabs/breakpoints';
import { SubHeading } from './sub-heading';
import { SubItem } from './sub-item';
import { useNavigation } from '../context';
import { WIDTHS } from '../utils/constants';
var ChevronLeft = Icons.ChevronLeft;
var defaultStyles = StyleSheet({
  container: _objectSpread({
    height: '100%',
    backgroundColor: function backgroundColor(_ref) {
      var token = _ref.token;
      return token('navigation.subMenu.background.color', token('color.container.static.default'));
    }
  }, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: {
      width: function width(_ref2) {
        var token = _ref2.token;
        return token('navigation.mobile.subMenu.width', WIDTHS.SUB_MENU.MOBILE);
      }
    }
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: {
      width: function width(_ref3) {
        var token = _ref3.token;
        return token('navigation.tablet.subMenu.width', WIDTHS.SUB_MENU.TABLET);
      }
    }
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: {
      width: function width(_ref4) {
        var token = _ref4.token;
        return token('navigation.desktop.subMenu.width', WIDTHS.SUB_MENU.DESKTOP);
      }
    }
  }])),
  title: _objectSpread(_objectSpread(_objectSpread({
    cursor: 'pointer'
  }, text.styles({
    target: 'navigation.subMenu.title',
    fallback: 'normal.semibold'
  })), padding.styles({
    target: 'navigation.subMenu.title',
    all: 'm'
  })), border.styles({
    target: 'navigation.subMenu.title',
    bottom: {
      width: 'thin',
      color: 'container.static.light'
    }
  })),
  backIcon: {
    position: 'absolute'
  },
  menu: _objectSpread({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto'
  }, padding.styles({
    target: 'navigation.subMenu.items',
    y: 's'
  })),
  noPadding: _objectSpread({}, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: _objectSpread({}, padding.styles({
      top: 'none'
    }))
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: _objectSpread({}, padding.styles({
      top: 'none'
    }))
  }]))
});
export var SubMenu = /*#__PURE__*/forwardRef(function SubMenu(_ref5, ref) {
  var style = _ref5.style,
      className = _ref5.className,
      id = _ref5.id,
      _ref5$items = _ref5.items,
      items = _ref5$items === void 0 ? [] : _ref5$items,
      title = _ref5.title;
  var s = useStyles(defaultStyles);
  var token = useToken();

  var _useNavigation = useNavigation(),
      setActiveItem = _useNavigation.setActiveItem;

  return /*#__PURE__*/React.createElement(Box, _extends({}, s.with('container')({
    style: style,
    className: className
  }), {
    ref: ref,
    flexDirection: "column"
  }), title && /*#__PURE__*/React.createElement(Breakpoints, {
    queries: {
      maxWidth: 's'
    }
  }, /*#__PURE__*/React.createElement(Box, _extends({}, s('title'), {
    alignItems: "center",
    justifyContent: "space-between",
    onClick: function onClick() {
      setActiveItem(null);
    }
  }), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ChevronLeft, _extends({}, s('backIcon'), {
    size: "m"
  })), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    alignItems: "center",
    justifyContent: "center"
  }, title)))), /*#__PURE__*/React.createElement("menu", s('menu', {
    noPadding: !!title
  }), _mapInstanceProperty(items).call(items, function (item, index) {
    if ('items' in item) {
      var _items = item.items,
          rest = _objectWithoutProperties(item, _excluded);

      return /*#__PURE__*/React.createElement(Box, {
        flexDirection: "column",
        mt: index !== 0 ? token('spacing.l') : 0
      }, /*#__PURE__*/React.createElement(SubHeading, rest), _mapInstanceProperty(_items).call(_items, function (item, index) {
        return /*#__PURE__*/React.createElement(SubItem, _extends({}, item, {
          key: index,
          groupId: id
        }));
      }));
    }

    return /*#__PURE__*/React.createElement(SubItem, _extends({}, item, {
      key: index,
      groupId: id
    }));
  })));
});